// Libraries
import React from 'react';

// Components
import {CardBlock, CardText} from 'Components/flowChart/components/NodePreview/components/styled';

// Constants
import {FILTER_TYPE_LABEL} from 'Components/flowChart/components/NodePreview/components/NodeFilter/constants';
import {SEGMENT_TYPE_LABEL} from 'Components/flowChart/components/NodePreview/components/NodeYes/constants';

// Types
import {IMetadata} from 'Components/flowChart/components/NodePreview/components/NodeFilter/types';
import {INodePreviewProps} from 'Components/flowChart/components/NodePreview/types';

// Utils
import {countFilterSegments, countFilterUniqueAttrs} from 'Components/flowChart/utils';

const PATH = 'components/components/flowChart/components/Card/components/NodeFilter/index.tsx';

export interface INodeFilter extends INodePreviewProps<IMetadata> {}

const NodeFilter: React.FC<INodeFilter> = (props) => {
	try {
		const {
			node: {metadata}
		} = props;
		const {filterType} = metadata;

		if (filterType === 'user_attribute' || filterType === 'customer_attribute') {
			const {filterType, filters} = metadata;
			const numAttributes = countFilterUniqueAttrs(filters);

			return (
				<>
					<CardBlock>
						<CardText>Filter by audience attribute</CardText>
					</CardBlock>
					<CardBlock>
						<CardText>Condition:</CardText>
						<CardText>{`Target to ${FILTER_TYPE_LABEL[filterType]}`}</CardText>
						<CardText>{`Have ${numAttributes} attribute(s)`}</CardText>
					</CardBlock>
				</>
			);
		}

		if (filterType === 'item_segment') {
			const {audienceSegmentType, excludedFilters, filters} = metadata;

			const numIncluded = countFilterSegments(filters);
			const numExcluded = countFilterSegments(excludedFilters!);

			return (
				<>
					<CardBlock>
						<CardText>Filter by audience segment</CardText>
					</CardBlock>
					<CardBlock>
						<CardText>Condition:</CardText>
						{numIncluded > 0 && (
							<CardText>{`Included ${numIncluded} ${SEGMENT_TYPE_LABEL[audienceSegmentType!]} segment(s)`}</CardText>
						)}
						{numExcluded > 0 && (
							<CardText>{`Excluded ${numExcluded} ${SEGMENT_TYPE_LABEL[audienceSegmentType!]} segment(s)`}</CardText>
						)}
					</CardBlock>
				</>
			);
		}

		if (filterType === 'event_attribute') {
			const {filters} = metadata;

			const numAttributes = countFilterUniqueAttrs(filters);

			return (
				<>
					<CardBlock>
						<CardText>Filter by trigger event attribute</CardText>
					</CardBlock>
					<CardBlock>
						<CardText>Condition:</CardText>
						<CardText>{`Have ${numAttributes} attribute(s)`}</CardText>
					</CardBlock>
				</>
			);
		}

		return null;
	} catch (e) {
		props.onError?.(e, {
			component: PATH,
			action: 'render -> NodeFilter',
			args: {props}
		});

		return null;
	}
};

export default NodeFilter;
